import { accountsActions, accountsSelectors } from 'app-components/flux/accounts';
import { categoriesActions, categoriesSelectors } from 'app-components/flux/categories';
import { tagsActions, tagsSelectors } from 'app-components/flux/tags';
import { transactionsActions, transactionsSelectors } from 'app-components/flux/transactions';
import { fetchOnce } from 'app-components/hooks/utils';

/** Refresh route resources on entry while sharing requests already in flight. */
export function loadTransactions(): null {
  fetchOnce(accountsActions.getAccounts, accountsSelectors, true);
  fetchOnce(transactionsActions.getTransactions, transactionsSelectors, true);
  fetchOnce(categoriesActions.getCategories, categoriesSelectors, true);
  fetchOnce(tagsActions.getTags, tagsSelectors, true);
  return null;
}
